export const WORDS = [
  'İCAZƏ',
  'ALMAZ',
  'MAKAO',
  'ŞİRLİ',
  'KÜPÇƏ',
  'GÜMAN',
  'DİŞDİ',
  'TƏKAN',
  'KEFAL',
  'OLMAQ',
  'GİRLİ',
  'KƏRDƏ',
  'BİDAR',
  'DÜZGÜ',
  'ÇÖLMƏ',
  'EPONJ',
  'MƏRCİ',
  'BEYƏT',
  'KƏSƏK',
  'RUSCA',
  'KAMAL',
  'KVARS',
  'QƏMZƏ',
  'İZAFƏ',
  'MİFİK',
  'TUFAN',
  'TÖRPÜ',
  'SƏBƏB',
  'BABAL',
  'SABAH',
  'NÖQTƏ',
  'SADİQ',
  'ÇÖKƏK',
  'QƏBİL',
  'KÜLLİ',
  'SATMA',
  'BAŞQA',
  'CUVAR',
  'DAVAT',
  'QAÇAN',
  'NƏMİŞ',
  'ÇİYAN',
  'NOXUD',
  'CÜRƏT',
  'DÜNYA',
  'CİNSİ',
  'İSƏVİ',
  'DİBLİ',
  'ƏNQAZ',
  'MUNQU',
  'NÖKƏR',
  'DİLİK',
  'ÇOBAN',
  'SEYİD',
  'QƏCƏC',
  'ÇÜRÜK',
  'DÖNÜŞ',
  'SARJA',
  'QALAY',
  'DÜRGƏ',
  'QƏMİŞ',
  'TİNƏT',
  'CƏBƏL',
  'KAFUR',
  'DALAB',
  'NOVLU',
  'LİMAN',
  'MİNMƏ',
  'TÜRKÜ',
  'KİTRƏ',
  'İHATƏ',
  'FİKİR',
  'MİSAL',
  'ŞƏKİL',
  'PEYİN',
  'QUCAQ',
  'CALAQ',
  'ƏFKAR',
  'EYİCƏ',
  'DƏYƏR',
  'CÜBBƏ',
  'JETON',
  'ÇOTUR',
  'MENNO',
  'FİTNƏ',
  'ÇUQUN',
  'MÖVLA',
  'RUHƏN',
  'RADİO',
  'DAXAL',
  'TİLOV',
  'DİNGİ',
  'ƏŞRAF',
  'TEMBR',
  'MEYOZ',
  'SPORT',
  'LƏÇƏK',
  'ƏCLAF',
  'CİLVƏ',
  'DÜRLÜ',
  'ABDUQ',
  'BİDAD',
  'KÜNYƏ',
  'LİBAS',
  'AŞQAL',
  'EYVAN',
  'NÜSXƏ',
  'BİBAK',
  'MAYOR',
  'QRANT',
  'DİZEL',
  'KATİB',
  'AMORF',
  'GÖRMƏ',
  'ÇƏRƏN',
  'SÖNMƏ',
  'BAYQU',
  'İSPAN',
  'QADİR',
  'LƏNƏT',
  'TABAQ',
  'MƏGƏR',
  'RÜMUZ',
  'ƏYANİ',
  'LƏRZƏ',
  'ANMAQ',
  'İSRAR',
  'İŞRƏT',
  'KƏRKƏ',
  'QAZON',
  'DURNA',
  'CÜYÜR',
  'ƏHƏNG',
  'DƏMƏK',
  'QİYAS',
  'NOXTA',
  'GETMƏ',
  'ƏCƏBA',
  'MƏLƏK',
  'ÇƏKİK',
  'BİRƏR',
  'SİNİR',
  'RUTİL',
  'EYVAY',
  'MAZAQ',
  'GƏLİR',
  'TƏRSƏ',
  'ÇUVAL',
  'İDEYA',
  'BƏDİİ',
  'DEKAN',
  'RƏSMİ',
  'UDLAQ',
  'DURUŞ',
  'PAUZA',
  'KRANT',
  'MAHNA',
  'ÇİLLƏ',
  'QƏZƏB',
  'ƏQƏLL',
  'TƏRSA',
  'FİLİZ',
  'HƏRBƏ',
  'LİNZA',
  'BİLƏN',
  'ATBAZ',
  'MÖVQE',
  'SƏMƏR',
  'SERUM',
  'FİBRA',
  'BİBƏR',
  'TUTUQ',
  'DREYF',
  'İCMAL',
  'KÖÇMƏ',
  'TƏTİK',
  'ÖVSAF',
  'SÖVDA',
  'NAŞİR',
  'SÜYÜM',
  'ERKƏC',
  'PALMA',
  'MUZEY',
  'ƏCƏMİ',
  'SUMKA',
  'SADAQ',
  'QULAM',
  'ÖDLÜK',
  'DÖYƏC',
  'ŞASSİ',
  'MƏRMİ',
  'DÜZƏN',
  'KƏTAN',
  'QUMAR',
  'ƏZGİN',
  'KƏRÇƏ',
  'KASNİ',
  'MÜHÜM',
  'ATLAZ',
  'SÜSLÜ',
  'QOPMA',
  'QÜDDƏ',
  'APORT',
  'LOMBA',
  'QÜLLƏ',
  'ONLUQ',
  'HƏSƏD',
  'SİNƏK',
  'TALİB',
  'ƏKNAF',
  'NATİQ',
  'SƏYLİ',
  'MOYVA',
  'İRŞAD',
  'CUHUD',
  'QORUT',
  'QONAQ',
  'KATER',
  'DİGƏR',
  'ÇÖLÇÜ',
  'KONKA',
  'GÖYLÜ',
  'ƏFLAK',
  'QAZEL',
  'SİÇAN',
  'FİKUS',
  'GİLLİ',
  'BEHLİ',
  'ƏSMƏR',
  'HÖRMƏ',
  'TOYUQ',
  'HASİL',
  'ALANA',
  'BADAQ',
  'MANQA',
  'TAFTA',
  'ƏHSƏN',
  'FƏRLİ',
  'MATAH',
  'ƏDƏDİ',
  'QƏLPƏ',
  'ƏSGƏR',
  'BOÇKA',
  'MÜBAH',
  'DÖZÜŞ',
  'MÜHİB',
  'ƏQDƏS',
  'QUTLU',
  'SELVA',
  'LÖVHƏ',
  'QƏHVƏ',
  'HƏZİN',
  'İDARƏ',
  'ƏYLƏC',
  'İSRİF',
  'KUKLA',
  'KƏPƏK',
  'AQAVA',
  'NAÇAR',
  'BUXOV',
  'EOLİT',
  'LİMFA',
  'İŞARƏ',
  'ÇEVİK',
  'DÜMBƏ',
  'NİYAZ',
  'ŞAŞKA',
  'DUAGU',
  'RƏCƏZ',
  'MÖVÜC',
  'SİNOD',
  'QOTİK',
  'MƏRƏK',
  'BİDƏT',
  'EVCİL',
  'ƏBRƏŞ',
  'QRAFA',
  'KÖPPƏ',
  'ŞKALA',
  'QƏLƏT',
  'QƏBZƏ',
  'TAXÇA',
  'SƏLBƏ',
  'HALVA',
  'CADDƏ',
  'LAPCA',
  'ORADA',
  'HƏRFİ',
  'NÖYÜT',
  'FÜZUL',
  'ƏRBAB',
  'KOBUD',
  'LEQAL',
  'MƏLUN',
  'EVSAF',
  'QƏRİB',
  'KÜPÇÜ',
  'ÇOCUQ',
  'BİÇİN',
  'ALLAF',
  'DAHAN',
  'ÇOXCA',
  'QOVMA',
  'DÖLÇÜ',
  'HALƏT',
  'TƏRİF',
  'QİYMƏ',
  'GƏVƏŞ',
  'NƏDƏN',
  'DƏLMƏ',
  'KƏSƏN',
  'ULTRA',
  'MƏSUL',
  'LÖYÜN',
  'OXUMA',
  'ƏLBƏT',
  'MODUL',
  'KÜSKÜ',
  'BULKA',
  'DƏRBƏ',
  'QƏTAR',
  'ƏLEYH',
  'ƏTSİZ',
  'DİŞƏK',
  'LİANA',
  'İSLAH',
  'BLUZA',
  'MADDİ',
  'QATİL',
  'ALİYƏ',
  'MƏRƏZ',
  'OVXAQ',
  'İZZƏT',
  'GİMGƏ',
  'AYSOR',
  'ƏRSİZ',
  'KÜRDÜ',
  'HAKİM',
  'SUTKA',
  'ABORT',
  'ÜLFƏT',
  'SUCUQ',
  'İRSAL',
  'SİLAH',
  'HƏYƏT',
  'BİRCƏ',
  'EVDAR',
  'DOQMA',
  'İŞDƏK',
  'ÜÇBİR',
  'JİLET',
  'QOPUZ',
  'BUCAQ',
  'LAHUT',
  'SPİRT',
  'RAMPA',
  'MƏMUL',
  'GÖRÜŞ',
  'PULLU',
  'KÖMƏK',
  'ÇATAL',
  'ORTİT',
  'SƏFEH',
  'BİKAR',
  'ƏTTAR',
  'GEYSU',
  'BEMOL',
  'İTLİK',
  'BƏKÇİ',
  'SÜRƏT',
  'SABİQ',
  'DİŞLİ',
  'MÜRGÜ',
  'ŞTRİX',
  'NİHAN',
  'MİZAN',
  'ALEUT',
  'MƏXƏZ',
  'MƏMNU',
  'PLOMB',
  'ƏMƏLƏ',
  'ƏNBƏR',
  'MİLİS',
  'KAPOT',
  'UNTER',
  'MUTON',
  'HƏVƏS',
  'DİYİN',
  'RƏQİQ',
  'RATİN',
  'LƏZGİ',
  'İLLƏT',
  'MADAR',
  'HOPPA',
  'NAZİR',
  'PARİK',
  'BÜDCƏ',
  'ODLUQ',
  'MOBİL',
  'GETTO',
  'SAQQA',
  'BUXUR',
  'ƏYDƏM',
  'ASTMA',
  'TOXAC',
  'ƏNTİQ',
  'KÜSƏN',
  'SƏRAB',
  'GİRVƏ',
  'GÜLGÜ',
  'DÜRƏK',
  'FARSİ',
  'MİTİL',
  'MİTRA',
  'AVİZO',
  'SƏRƏK',
  'BÜRQƏ',
  'GİRGİ',
  'RAUND',
  'ƏHVAL',
  'BƏHRİ',
  'ÇEŞNİ',
  'İLAHİ',
  'KEPKA',
  'İNSAF',
  'DUZÇU',
  'BADAŞ',
  'QORLU',
  'MƏLİH',
  'İSLAQ',
  'NÖVBƏ',
  'ƏRİMƏ',
  'ƏDƏSƏ',
  'PƏRQU',
  'HÜRUF',
  'MİLAD',
  'ABXOR',
  'REKON',
  'BİKEF',
  'ŞTREK',
  'İRÇAL',
  'FÜNUN',
  'GÜLMƏ',
  'ƏBƏÇİ',
  'ÇƏPİŞ',
  'ÇOXLU',
  'ŞOFER',
  'ÇİLİK',
  'TƏMİZ',
  'TAMAH',
  'HƏKİM',
  'HANDA',
  'TİMOL',
  'TAKSİ',
  'LAZER',
  'ASLAN',
  'BAFTA',
  'HAMİL',
  'İŞBAZ',
  'BUKET',
  'QAZAX',
  'DAMMA',
  'EYMƏN',
  'İXLAS',
  'LEHMƏ',
  'ELDAŞ',
  'GƏLİN',
  'ADƏTA',
  'GƏRÇİ',
  'ŞƏRTİ',
  'MORUQ',
  'ANKET',
  'OMEQA',
  'NƏCİB',
  'FACİƏ',
  'POZAN',
  'TAXTA',
  'QƏZƏL',
  'HACƏT',
  'BURUN',
  'ƏXƏVİ',
  'BURMA',
  'BAHƏM',
  'SFERA',
  'HÖYÜŞ',
  'ƏNDUH',
  'İMMUN',
  'ŞÜMAR',
  'TATAR',
  'İDDİA',
  'İSNAD',
  'KÖHÜL',
  'MİRZƏ',
  'BÜLÖV',
  'PİKET',
  'CİNAH',
  'TORİT',
  'KUPON',
  'KİSEL',
  'QURUŞ',
  'TƏMİN',
  'TİKİŞ',
  'İRFAN',
  'HƏBİB',
  'GÖYƏM',
  'ŞİXTA',
  'HATƏM',
  'İFADƏ',
  'NAQAN',
  'HƏTTA',
  'BİRUN',
  'FLORA',
  'BANKƏ',
  'CALAL',
  'MÖMİN',
  'KƏDƏR',
  'CÜZVİ',
  'ƏMİRİ',
  'BİZAR',
  'KASAD',
  'SƏCDƏ',
  'QƏMLİ',
  'İLAVƏ',
  'BİƏQL',
  'PARAD',
  'QALMA',
  'İPRİT',
  'ABİDƏ',
  'ETİNA',
  'SALON',
  'TALAQ',
  'ALAFA',
  'MƏZAC',
  'DAXMA',
  'TİNGƏ',
  'GENCƏ',
  'TOZLU',
  'SİNFİ',
  'DAŞKA',
  'ƏLDƏN',
  'QLAVA',
  'KİÇİK',
  'BƏRPA',
  'PİTİK',
  'FÜSUN',
  'İNQUŞ',
  'QÖVSİ',
  'MİLƏL',
  'BİQAL',
  'LİKÖR',
  'BÜRKÜ',
  'SÜVAR',
  'GÜVƏC',
  'MOFET',
  'İKİCƏ',
  'TANİN',
  'QƏBUL',
  'FƏTİR',
  'TABLO',
  'KƏLİK',
  'TÜTÜN',
  'OBRAZ',
  'QORUQ',
  'CİYİL',
  'KAFEL',
  'FƏRAR',
  'KİRZA',
  'NAXOŞ',
  'MƏKAN',
  'KORUŞ',
  'ŞİFON',
  'İFTAR',
  'BİRGƏ',
  'İPSİZ',
  'ƏKKAS',
  'REYKA',
  'ƏRGƏN',
  'FASİQ',
  'HEYBƏ',
  'SABİT',
  'DÜNƏN',
  'SEVMƏ',
  'DASİT',
  'BİGAR',
  'OKSİD',
  'AXSAR',
  'ŞAQUL',
  'RƏMƏL',
  'DEŞMƏ',
  'ÇƏKİC',
  'CECİM',
  'CƏSƏD',
  'BİLLƏ',
  'CANAN',
  'NAXAH',
  'BÜTÖV',
  'DAİMİ',
  'TƏLİM',
  'MEDİA',
  'NAKAM',
  'TƏPƏL',
  'NƏQLİ',
  'PİFOS',
  'KEÇİD',
  'RƏŞİD',
  'GÜDMƏ',
  'KİTEL',
  'ƏNVƏR',
  'QƏDƏH',
  'QUZEY',
  'MƏBUD',
  'İFFƏT',
  'KAHİN',
  'DAYNA',
  'ONLAR',
  'DƏNİZ',
  'ÖNCÜL',
  'DEYİL',
  'KALKA',
  'ÇƏPƏR',
  'MƏKİK',
  'SELLİ',
  'SƏHRA',
  'REBUS',
  'DİLİM',
  'PALTO',
  'MEYİT',
  'TOQQA',
  'MƏLƏS',
  'ELMLİ',
  'ƏRDƏM',
  'QUSAR',
  'SEGAH',
  'CƏBHƏ',
  'LƏYƏN',
  'RÜKƏT',
  'ESKİZ',
  'MORFİ',
  'LİFLİ',
  'ŞİRİN',
  'İANƏT',
  'ÇƏKMƏ',
  'AZADƏ',
  'FONEM',
  'TARAZ',
  'ƏRLİK',
  'RULON',
  'NAŞAD',
  'SANKİ',
  'SARAY',
  'KİRPİ',
  'SÖVDƏ',
  'POTAŞ',
  'DİLİR',
  'SUBAY',
  'MUFTA',
  'HESAB',
  'BEZİK',
  'MƏLUL',
  'ÇAXMA',
  'İONLU',
  'ÇARSU',
  'MÜNŞİ',
  'MOQAR',
  'BADAR',
  'DOLAY',
  'İRQÇİ',
  'BUXÇA',
  'QÜVVƏ',
  'ƏBYƏZ',
  'AHƏNG',
  'FRAZA',
  'KƏSİM',
  'LAMPA',
  'OTSUZ',
  'ATLET',
  'QAPAZ',
  'QƏBİR',
  'GÜYÜM',
  'KÜLƏŞ',
  'LİCİM',
  'RUMBA',
  'İSLAM',
  'LEYLİ',
  'UMMAQ',
  'ŞORTU',
  'QOYMA',
  'PEDAL',
  'QURNA',
  'MOPED',
  'BƏRAT',
  'MASON',
  'PAPKA',
  'CİZGİ',
  'DÜDƏK',
  'QİSAS',
  'KUFUL',
  'BƏLİM',
  'BİÇİM',
  'QUSLİ',
  'ETİKA',
  'ÇOVUŞ',
  'ƏQLƏN',
  'EYZƏN',
  'ŞAKƏR',
  'NƏFLİ',
  'BİKƏS',
  'DİYAR',
  'ÖZBƏK',
  'MESSO',
  'GİRİŞ',
  'TƏLƏB',
  'QEYRİ',
  'KAKİL',
  'ƏFQAN',
  'DÜYDÜ',
  'MÜLKİ',
  'SAMUR',
  'ŞTAMM',
  'ŞƏHLA',
  'QƏHƏT',
  'ƏZMLİ',
  'LƏKƏR',
  'DOŞAB',
  'CÜLUS',
  'NAGAH',
  'SUMAQ',
  'İRMAQ',
  'BƏHAİ',
  'ABUNƏ',
  'SKETÇ',
  'EVSİZ',
  'SİDİK',
  'BƏNİZ',
  'QÜNNƏ',
  'QAXMA',
  'TOKAR',
  'SELEN',
  'DEİST',
  'HALAL',
  'ŞİŞİK',
  'PƏLMƏ',
  'ÜLGÜC',
  'MİSRA',
  'CİDDİ',
  'SİTAL',
  'BRONX',
  'KÜYLÜ',
  'QİSİM',
  'FİNİŞ',
  'HƏLAK',
  'LEYKA',
  'TƏRƏK',
  'LƏZİZ',
  'NANAY',
  'ƏMMƏK',
  'MULAT',
  'TOVUZ',
  'ORTAM',
  'CÜSSƏ',
  'ƏJDƏR',
  'REZİN',
  'ŞAYAN',
  'BƏNDƏ',
  'START',
  'NƏMƏR',
  'NAZİL',
  'RAHİB',
  'QALOŞ',
  'PƏNCƏ',
  'BAYAQ',
  'MEMAR',
  'TALAN',
  'BEZAR',
  'SƏRKİ',
  'ƏFZUN',
  'LİFÇİ',
  'TÖVBƏ',
  'ŞÜMÜR',
  'HİSLİ',
  'DİNİŞ',
  'SAVAŞ',
  'LİMON',
  'İLAHƏ',
  'ÇİYİD',
  'SARMA',
  'TABAN',
  'TRUBA',
  'GÜBRƏ',
  'SAMBO',
  'ÖLMƏZ',
  'JULİK',
  'TORNA',
  'QADAQ',
  'ÖRTMƏ',
  'RƏYÇİ',
  'NAZİM',
  'TİRLİ',
  'İÇƏRİ',
  'DARAM',
  'NEHRƏ',
  'ARMUD',
  'ƏHRAM',
  'ÇƏRƏZ',
  'BİRUH',
  'SƏNƏM',
  'BEYİN',
  'SƏHİH',
  'KƏNAF',
  'ŞTAMP',
  'ƏSRİK',
  'İFRAT',
  'DEKOR',
  'ƏMSAL',
  'LƏÇƏR',
  'DÖYÜŞ',
  'UNLUQ',
  'ÖLÇMƏ',
  'DÜZÜŞ',
  'ORTAQ',
  'GAVUR',
  'DİLÇƏ',
  'KƏNAR',
  'MAHİR',
  'ÇƏPƏL',
  'BƏNGİ',
  'DOSTU',
  'QOHUM',
  'ƏMİCİ',
  'SÜFRƏ',
  'HİCAZ',
  'QOLAC',
  'KƏSİK',
  'BİŞMƏ',
  'ƏDYAN',
  'ƏZDAD',
  'ADRES',
  'DEBİT',
  'QİLAF',
  'MÖHRƏ',
  'NƏSİL',
  'İRİCƏ',
  'ÇİNAR',
  'JAKET',
  'ƏLHAY',
  'ƏDƏBİ',
  'HƏYAT',
  'GƏDİK',
  'FƏSİL',
  'GEYİŞ',
  'KEŞİŞ',
  'PAROL',
  'SƏBZİ',
  'DƏFNƏ',
  'TUNEL',
  'ŞİTAB',
  'GERZE',
  'ALBOM',
  'LAKİN',
  'DEBET',
  'APREL',
  'TUTMA',
  'KALBA',
  'NÜFUZ',
  'ÇADRA',
  'İZSİZ',
  'ABDAR',
  'MƏCUN',
  'KÜFTƏ',
  'BİÇİZ',
  'CİHAZ',
  'TORTA',
  'ALUDƏ',
  'İŞCİL',
  'BALET',
  'QULUN',
  'ŞƏKƏR',
  'TAPAN',
  'SALAM',
  'NƏŞAT',
  'MƏŞUQ',
  'KÖHNƏ',
  'PANEL',
  'EHMAL',
  'HASAR',
  'KÜRRƏ',
  'ƏLZƏM',
  'ŞİBİD',
  'TÜNÜK',
  'İPÇİN',
  'BETON',
  'QƏLİB',
  'TENOR',
  'BUDAQ',
  'ARİYA',
  'KÜSMƏ',
  'FİLAN',
  'BEKON',
  'RƏŞMƏ',
  'BÜKÜM',
  'NONET',
  'İCLAS',
  'MƏDƏN',
  'MƏLƏR',
  'PƏPƏŞ',
  'ƏŞRƏF',
  'BƏDXU',
  'İSMƏT',
  'NƏFİS',
  'QOÇAQ',
  'ƏTVAR',
  'MƏNFİ',
  'PASAJ',
  'SONOR',
  'KİMYA',
  'KƏSİF',
  'İLMƏK',
  'KƏLƏK',
  'RÜFƏT',
  'CİNAS',
  'AREAL',
  'DAVLA',
  'HORRA',
  'BİTİK',
  'UCLUQ',
  'İTMAM',
  'CEHİZ',
  'TEİZM',
  'NAHAR',
  'DOSYE',
  'BƏHƏR',
  'ÇULLU',
  'İCARƏ',
  'SÜFLƏ',
  'İNTİM',
  'SİSLİ',
  'ORBİT',
  'TÜMƏN',
  'OTLUQ',
  'TƏMİR',
  'DONUZ',
  'HÜRMƏ',
  'SƏPİN',
  'HİNDU',
  'MANAT',
  'UMSUQ',
  'ƏNHAR',
  'PÜXTƏ',
  'TAYQA',
  'CƏSİM',
  'SİTƏM',
  'SAHİL',
  'SİNQA',
  'SƏFİR',
  'TÖHFƏ',
  'ÇOMAQ',
  'GÖBƏK',
  'QURUT',
  'BƏZƏK',
  'PATKA',
  'TİPAJ',
  'FİNCƏ',
  'POEMA',
  'PALAZ',
  'GÜDAZ',
  'MİYAN',
  'SƏBƏT',
  'ŞİRÇİ',
  'SAYAD',
  'QƏFİL',
  'CİZYƏ',
  'ƏCAİB',
  'PLATO',
  'KİLİD',
  'BAYAZ',
  'NANDİ',
  'KƏRKİ',
  'ƏMZİK',
  'SƏHNƏ',
  'KÖPƏŞ',
  'DİKTƏ',
  'HƏMİN',
  'KƏNİZ',
  'ƏLSİZ',
  'MİNİŞ',
  'KEÇƏN',
  'MƏSUD',
  'NÜTFƏ',
  'TƏPİK',
  'ƏBCƏD',
  'ABSES',
  'RİÇAL',
  'DEŞİK',
  'GODUL',
  'ŞƏŞƏƏ',
  'SÜRGÜ',
  'KİLİM',
  'SİYAL',
  'QƏLBİ',
  'DÖNGƏ',
  'NOTLU',
  'HƏMƏL',
  'RƏXNƏ',
  'KÖÇƏL',
  'ŞAHAD',
  'CÜTÇÜ',
  'QAPAQ',
  'ƏRVAH',
  'DONOS',
  'TAMET',
  'MƏZUN',
  'DÖNÜM',
  'KEYSU',
  'ŞƏXSİ',
  'İÇSİZ',
  'RADAR',
  'OXUCU',
  'HƏRZƏ',
  'KƏLMƏ',
  'İSRAF',
  'FİRQƏ',
  'ƏBƏDİ',
  'MAHUR',
  'ŞÜLƏK',
  'RALLİ',
  'TƏKİD',
  'GÜLƏR',
  'QƏLYƏ',
  'KLİŞE',
  'HƏDƏR',
  'ÖVRƏT',
  'TORBA',
  'DƏXİL',
  'RİŞTƏ',
  'ARÇAN',
  'FƏRƏC',
  'ƏLHAN',
  'ƏRVƏZ',
  'MEHLİ',
  'İTKİN',
  'NÜCUM',
  'ŞÜRUT',
  'İKİLİ',
  'NƏCAT',
  'MƏHƏK',
  'ÜRƏFA',
  'ARTMA',
  'DOYMA',
  'CİSİM',
  'DƏKKƏ',
  'BAZİS',
  'QƏTFƏ',
  'BİFƏR',
  'GİLEY',
  'RƏFİQ',
  'TARAC',
  'PİYAN',
  'BATAQ',
  'BAXAN',
  'KÖLGƏ',
  'KİOSK',
  'GƏDƏK',
  'QAİMƏ',
  'ATMAQ',
  'PİLTƏ',
  'QOPUQ',
  'FORUM',
  'SÖZLÜ',
  'ƏNCİR',
  'BEYZƏ',
  'ŞABAŞ',
  'FƏSAD',
  'LAZCA',
  'AYRAN',
  'KREDO',
  'SAZAN',
  'GÖDƏK',
  'BÖLGÜ',
  'KƏLÇƏ',
  'PİKAP',
  'SABUN',
  'NAMAZ',
  'SƏNƏD',
  'RUHLU',
  'ESTET',
  'AMPİR',
  'LAPAN',
  'ARVAD',
  'ƏRZAQ',
  'DÖNƏK',
  'TÜKLÜ',
  'SEVGİ',
  'OYNAR',
  'DƏMLİ',
  'RASTA',
  'KƏHƏR',
  'KÜŞTÜ',
  'BACAQ',
  'TUMAN',
  'AORTA',
  'SÜNGÜ',
  'DİLƏK',
  'SÜNNİ',
  'QAYMA',
  'ŞAYİƏ',
  'TAQƏT',
  'QÜSUR',
  'TƏKNƏ',
  'KƏLƏZ',
  'KÖBƏR',
  'MƏTİN',
  'DARAQ',
  'BATİL',
  'GÜLLÜ',
  'ETİLA',
  'ALAŞA',
  'AVŞAR',
  'QOVAN',
  'SOLÇU',
  'BARİT',
  'DAVAR',
  'DANMA',
  'ƏPPƏK',
  'ÇEŞMƏ',
  'QAZAN',
  'DÜVƏL',
  'QABAR',
  'SAPMA',
  'BİEYB',
  'BİVEC',
  'AŞİNA',
  'SEYİZ',
  'TƏRİQ',
  'QOBUR',
  'BAYAT',
  'ÖYÜMƏ',
  'RAHAT',
  'MAYAK',
  'SAZAQ',
  'ƏCDAD',
  'QONŞU',
  'FARAŞ',
  'ƏTLİK',
  'RƏQİB',
  'DÖŞLÜ',
  'PİŞİK',
  'MƏCUS',
  'MƏTLƏ',
  'OYNAŞ',
  'SƏRİH',
  'NOHUR',
  'HODAQ',
  'NANDU',
  'TOPUŞ',
  'QAQUM',
  'SÜTÜL',
  'NAQİL',
  'QUSMA',
  'EYNƏK',
  'MƏCAZ',
  'BİZON',
  'QUDUZ',
  'SƏRFƏ',
  'MƏDAR',
  'MANEƏ',
  'FİNKA',
  'HOVUR',
  'SANMA',
  'NİŞAN',
  'ƏSASİ',
  'ŞƏRİK',
  'ƏFZƏL',
  'AKSİZ',
  'HƏDİS',
  'ŞAHİD',
  'İRSƏN',
  'FƏLƏK',
  'GÜHƏR',
  'LEHİM',
  'ULDUZ',
  'DƏQİQ',
  'TOPUQ',
  'GORDA',
  'BAHAR',
  'ƏHMƏQ',
  'ƏNGƏC',
  'QORXU',
  'ƏMLAK',
  'NİMFA',
  'İSTƏK',
  'HƏNİR',
  'QƏSƏM',
  'QAMAK',
  'ƏKSİK',
  'DOLAQ',
  'QÜRUR',
  'BÜNYƏ',
  'HƏDƏF',
  'ÜÇLÜK',
  'OLMAZ',
  'KÜYÜL',
  'HƏMLƏ',
  'ÜFÜQİ',
  'FELƏN',
  'ŞARAP',
  'MOXER',
  'LOVLU',
  'DİNAR',
  'NALAN',
  'ARSEN',
  'GEYİK',
  'ÇEXOL',
  'İCBAR',
  'ƏXLAQ',
  'RƏZİL',
  'HİSSİ',
  'QOVUT',
  'AŞPAZ',
  'KOTUL',
  'TİPİK',
  'İNDƏN',
  'NADİR',
  'SƏLİS',
  'ÇİSƏK',
  'MÜSYÖ',
  'ŞƏRƏF',
  'ŞƏDİD',
  'ÇƏNGƏ',
  'ANQUT',
  'DİBƏK',
  'TÜSTÜ',
  'ÖTKÜN',
  'KÜLÜF',
  'HAMAN',
  'QƏTƏN',
  'KƏFƏN',
  'ƏYMƏK',
  'ƏMRAZ',
  'ALMAQ',
  'MUROV',
  'ƏYYAM',
  'SÜXUR',
  'KÜZLÜ',
  'EVCİK',
  'QOBUZ',
  'BEŞCƏ',
  'ƏHKAM',
  'CUMMA',
  'FİNAL',
  'PÜŞTƏ',
  'SÖYÜD',
  'ARABA',
  'ÇOLPA',
  'ÜMMAN',
  'GÜDÜK',
  'SEKTA',
  'MİNCƏ',
  'TƏQTİ',
  'ERKƏN',
  'SELAB',
  'DƏVAM',
  'QAZAQ',
  'BAYDA',
  'QULAQ',
  'MƏMƏŞ',
  'BARAK',
  'AFTAB',
  'BİTLİ',
  'BASİL',
  'SOVKA',
  'TALXA',
  'CƏHƏT',
  'DİRƏK',
  'BƏRNİ',
  'ŞULUM',
  'İMRİK',
  'CİBLİ',
  'SİFTƏ',
  'DİBİR',
  'DİDMƏ',
  'İRBİS',
  'BAYAN',
  'MİNOR',
  'TÜLƏK',
  'LƏLƏŞ',
  'MUXRU',
  'GİRYƏ',
  'İYHAM',
  'GİPÜR',
  'ƏTFAL',
  'CAVİD',
  'HAMAM',
  'TİMİK',
  'EŞŞƏK',
  'PENNİ',
  'TORAN',
  'SƏLƏM',
  'SALEH',
  'İLLİK',
  'KEÇƏL',
  'MÖHÜR',
  'GİYOV',
  'ƏLAQƏ',
  'TUFLİ',
  'NİQAB',
  'HOTEL',
  'KİRƏC',
  'TÜTƏK',
  'AŞQAR',
  'DƏVAT',
  'DONUQ',
  'SULAQ',
  'DİLLİ',
  'TOTEM',
  'ÜRCAH',
  'DÜZÜM',
  'BARAT',
  'ÇƏTƏN',
  'ÇƏMƏN',
  'MEDYE',
  'SƏBZƏ',
  'ERKER',
  'TÜLKÜ',
  'SİZCƏ',
  'SƏPGİ',
  'ENMƏK',
  'FƏQƏT',
  'ÖRNƏK',
  'TREST',
  'TƏMİM',
  'BÖLÜM',
  'FİZİK',
  'İZAFİ',
  'AFİŞA',
  'MUFEL',
  'FİDYƏ',
  'ŞƏRÇİ',
  'ŞAMİL',
  'ƏCƏLƏ',
  'HİKKƏ',
  'SOLUQ',
  'TƏLAŞ',
  'NƏSƏB',
  'KÜLAH',
  'İDXAL',
  'KAFİR',
  'LEKAL',
  'MOBUD',
  'HƏBƏŞ',
  'PADAR',
  'ACMAQ',
  'EYNƏN',
  'MÜRİD',
  'DÜŞÜK',
  'ŞORAN',
  'SALOL',
  'İBRİQ',
  'DEBUT',
  'ƏSƏBİ',
  'KVANT',
  'EYHAM',
  'LƏRGƏ',
  'DÜZMƏ',
  'ƏBLƏQ',
  'DÖNÜK',
  'QALAQ',
  'ƏQVAM',
  'GÖZƏM',
  'QAFİL',
  'QOVUN',
  'QƏZET',
  'QƏBİZ',
  'BƏBƏK',
  'ÇİBAN',
  'MƏRİZ',
  'QƏYUR',
  'DAVUL',
  'PAFOS',
  'GÜRUH',
  'QAMUS',
  'RONDO',
  'FƏSİH',
  'ƏSNAF',
  'CAVAB',
  'ŞİFER',
  'FİTVA',
  'EPİKA',
  'MARAQ',
  'QUMRU',
  'İMƏCİ',
  'SADİR',
  'SİRAT',
  'MATƏM',
  'MÜFTƏ',
  'İLQAR',
  'DƏRUN',
  'ŞİTİL',
  'CİHAD',
  'KABEL',
  'ƏXTƏR',
  'KROSS',
  'FƏNƏR',
  'DƏYMƏ',
  'HƏCMİ',
  'LƏHCƏ',
  'ŞƏFƏQ',
  'ƏRKAN',
  'DAVUŞ',
  'LİSAN',
  'EKRAN',
  'DÖŞƏK',
  'HƏMZƏ',
  'ÇƏNLİ',
  'NÖŞÜN',
  'KASTA',
  'ÖTKƏM',
  'DRAMA',
  'MOTEL',
  'ƏMCƏK',
  'UDUCU',
  'BUDKA',
  'TİRAN',
  'GÜZGÜ',
  'GİLAN',
  'GÜNƏŞ',
  'MİZAC',
  'NİZAM',
  'MOTİV',
  'MANEJ',
  'SİQAR',
  'PAKER',
  'CİDAR',
  'TUMLU',
  'QİSSƏ',
  'HAMAR',
  'FASON',
  'MƏNBƏ',
  'EHSAN',
  'TABUT',
  'ÇAPAQ',
  'SAUNA',
  'KÖNÜL',
  'NÖMRƏ',
  'MAİLİ',
  'SİKKƏ',
  'TƏŞƏR',
  'BÜKMƏ',
  'KOLLU',
  'PUSMA',
  'ABPAŞ',
  'ƏZİCİ',
  'FİTİL',
  'LƏQƏB',
  'İTBAZ',
  'DİDİK',
  'ƏCUZƏ',
  'DONMA',
  'TURAC',
  'LƏTİF',
  'ƏSNƏK',
  'HƏMAN',
  'DOMNA',
  'ƏQSAM',
  'QAXAC',
  'SÜQUT',
  'AKULƏ',
  'MİNİK',
  'GEYİM',
  'DİLOV',
  'ARTEL',
  'SÜKUT',
  'NİCAT',
  'HÜZUR',
  'OÇERK',
  'HƏNƏK',
  'MODEL',
  'KASKA',
  'ENLİK',
  'MOTAL',
  'HİCRİ',
  'JOKEY',
  'BÜDƏT',
  'OXDAN',
  'ÇƏRƏK',
  'SETAR',
  'ƏNGƏL',
  'QALAC',
  'SAVAB',
  'DİNÇİ',
  'FRANK',
  'MAZAT',
  'NAMLU',
  'ÇODAR',
  'SÖNÜK',
  'ALVER',
  'OVSAR',
  'GÜLÜŞ',
  'NƏQŞƏ',
  'UKLAD',
  'PÖHRƏ',
  'QOLAY',
  'QƏDİM',
  'BUZÇU',
  'SİLOS',
  'HİLLİ',
  'BİHUŞ',
  'ÖLMƏK',
  'QABİL',
  'GİZLİ',
  'NƏSİM',
  'NƏŞƏT',
  'DUMAN',
  'GƏRDƏ',
  'MƏRAM',
  'REVYU',
  'ƏSKEŞ',
  'KÖMÜR',
  'KÖVƏR',
  'MÜDAM',
  'SULUF',
  'ÇEVRƏ',
  'MUJİK',
  'NAKƏS',
  'SAYMA',
  'İLKCƏ',
  'QAYƏT',
  'PƏSAB',
  'ÖDÜNC',
  'GƏYAN',
  'RƏQƏM',
  'ENİNƏ',
  'GEDİŞ',
  'ƏRGİN',
  'AQRAR',
  'KƏSAD',
  'BAXYA',
  'NAQUS',
  'SİPƏR',
  'DÜMÜK',
  'ƏVVƏL',
  'BLANK',
  'HƏŞƏM',
  'SÜJET',
  'NAZİK',
  'PƏNBƏ',
  'ÖPMƏK',
  'DÜKAN',
  'FİLTR',
  'İRADİ',
  'KASSA',
  'TANQO',
  'NİSBİ',
  'ŞAPKA',
  'İNVAR',
  'AŞURA',
  'MEYVƏ',
  'KOTAN',
  'KATET',
  'METAL',
  'TƏNHA',
  'KUBİK',
  'BADAM',
  'BİLİŞ',
  'SOPLO',
  'GOPÇU',
  'KƏTİL',
  'HƏRBİ',
  'İÇLİK',
  'BƏYAZ',
  'DÜZƏK',
  'EVLAD',
  'İÇİCİ',
  'QƏHƏR',
  'DABAN',
  'SOYMA',
  'QƏLİZ',
  'İDİOT',
  'ƏNGİN',
  'TİRMƏ',
  'TƏBİL',
  'KAQOR',
  'KƏSƏR',
  'TƏTİL',
  'KÖSÖV',
  'TOMAT',
  'ÇƏKİM',
  'KALTA',
  'TƏLƏF',
  'PİLOT',
  'DONLU',
  'KİFİR',
  'FƏQİR',
  'QARƏT',
  'HƏDİK',
  'DÜŞMƏ',
  'PARAF',
  'BAQAJ',
  'CAVAN',
  'İDRAK',
  'DUYMA',
  'OVQAT',
  'NÜANS',
  'ƏSKİK',
  'ETMƏK',
  'FANER',
  'LATUN',
  'SƏPKİ',
  'ÇİVZƏ',
  'OVUCU',
  'OXLUQ',
  'TABEL',
  'MOBƏD',
  'KOŞƏK',
  'ƏFSƏR',
  'DƏMƏT',
  'ƏZMƏK',
  'BƏLLİ',
  'BÖLƏN',
  'OPERA',
  'MƏKUS',
  'QASİB',
  'SÖKÜK',
  'PANNO',
  'ƏZGİL',
  'ƏFSUN',
  'BÖLÜK',
  'MAQMA',
  'ŞİRNİ',
  'RÜTBƏ',
  'SİZAL',
  'KOVXA',
  'NAPAK',
  'SAKİT',
  'ƏSLƏN',
  'TAVOT',
  'SƏBAT',
  'DEVİK',
  'SAYQA',
  'KAKAO',
  'İFLAS',
  'ARENA',
  'İBLİS',
  'ƏLLİK',
  'ƏLƏMƏ',
  'İYSİZ',
  'ÇİMMƏ',
  'ƏHMƏR',
  'RƏMZİ',
  'DÜKÇƏ',
  'KƏLLƏ',
  'SƏFRA',
  'ABXAZ',
  'ƏNZAR',
  'KULAK',
  'BAREL',
  'DƏHAN',
  'FASİD',
  'MEDAL',
  'MATAN',
  'İRƏLİ',
  'ÇÖMÇƏ',
  'EHSAS',
  'CİKKƏ',
  'ƏFYUN',
  'ÖDDƏK',
  'QOŞQU',
  'ÇİLLİ',
  'LEMMA',
  'DÖYCƏ',
  'AŞKAR',
  'İRƏMƏ',
  'BÖYÜK',
  'BALTA',
  'DAVAM',
  'ƏNƏNƏ',
  'HÜRÜŞ',
  'KƏLƏM',
  'FETİŞ',
  'NİKEL',
  'ANLAQ',
  'TƏBİİ',
  'SAMAN',
  'SİNEL',
  'GÜNAH',
  'GÜNEY',
  'DAMAR',
  'KAFƏR',
  'ÜLƏMA',
  'LİSEY',
  'ŞİŞMƏ',
  'ŞEVRO',
  'BİDEH',
  'BƏDƏN',
  'BİDİN',
  'QÜBBƏ',
  'DAYAZ',
  'ÇÖKMƏ',
  'JALÜZ',
  'DAMAD',
  'KƏMAN',
  'MƏSUM',
  'TÖYCÜ',
  'AVANS',
  'KOLİT',
  'KİNLİ',
  'BİLİK',
  'NETTO',
  'KƏYAN',
  'ŞOŞAQ',
  'DƏRYA',
  'BURUM',
  'LABÜD',
  'FASAD',
  'BURAZ',
  'BƏLƏN',
  'NÜKTƏ',
  'BUZLU',
  'ÇATAQ',
  'SÜTUN',
  'DARCA',
  'BƏXUR',
  'ELƏCƏ',
  'TƏMAS',
  'MİLÇƏ',
  'PİLİK',
  'ÖVLAD',
  'DÖZÜM',
  'ƏMVAL',
  'MEBEL',
  'MADƏR',
  'DƏMİR',
  'ƏFŞAN',
  'GÖZƏL',
  'ASRAL',
  'ÇƏRÇİ',
  'ŞURUP',
  'RÜBAİ',
  'ARTAN',
  'PƏTƏK',
  'MUNİS',
  'GİRİZ',
  'İYCİL',
  'KƏSƏB',
  'BƏDİR',
  'DƏRMƏ',
  'DALMA',
  'LƏMPƏ',
  'TÜTMƏ',
  'GÜRCÜ',
  'AVAND',
  'LOTOS',
  'İSHAL',
  'AVTOL',
  'MEZON',
  'SİLVİ',
  'SÜRFƏ',
  'İRADƏ',
  'QULAN',
  'OKEAN',
  'MƏZUR',
  'ASORİ',
  'NİGAR',
  'ƏNVAR',
  'KAHAL',
  'GÜLLƏ',
  'MALAX',
  'TOTUQ',
  'PÜŞTİ',
  'RİKŞA',
  'OVLAQ',
  'BUXTA',
  'BUFER',
  'ƏKİLİ',
  'QUTAB',
  'HOVUZ',
  'İTMƏK',
  'SİNUS',
  'ŞATİR',
  'TƏYİN',
  'QABAN',
  'BOYUN',
  'ƏRCİK',
  'İZHAR',
  'SƏRGİ',
  'ŞTİFT',
  'SÜDUR',
  'TACİR',
  'DƏNAB',
  'MƏQUL',
  'ƏMUDİ',
  'AYLAM',
  'SƏRÇƏ',
  'SİNMƏ',
  'CƏNGİ',
  'NURLU',
  'MİXƏK',
  'CAMAL',
  'BƏSTİ',
  'GÜNYƏ',
  'QOVUQ',
  'BARON',
  'DAQQA',
  'GƏRƏK',
  'ƏMGƏK',
  'HİLAL',
  'MİRAS',
  'İLƏRİ',
  'SULUQ',
  'SİNİF',
  'SÜKUN',
  'QƏMƏR',
  'QANAD',
  'KÖŞƏN',
  'TƏBİB',
  'İNCİK',
  'SENAT',
  'ROBOT',
  'NEYÇİ',
  'İPLİK',
  'ŞƏLTƏ',
  'ƏTƏNƏ',
  'KATTA',
  'ERKƏK',
  'QOTAZ',
  'ƏRƏFƏ',
  'ƏTMƏK',
  'SƏNƏK',
  'EŞSİZ',
  'BEÇÇƏ',
  'KİRLİ',
  'İYİMƏ',
  'ƏLAVƏ',
  'ÇUXUR',
  'GƏLİM',
  'CADAR',
  'KİRVƏ',
  'APTEK',
  'BƏDƏL',
  'HÜDUD',
  'ŞƏHAB',
  'ƏZƏLİ',
  'HƏQİR',
  'UCQAR',
  'MƏYUS',
  'DİŞRƏ',
  'KAŞNE',
  'SEÇİM',
  'DETAL',
  'ÇOPUR',
  'RAKET',
  'QƏTRƏ',
  'ÖRDƏK',
  'ASUDƏ',
  'OTLAQ',
  'TƏLİF',
  'FƏXRİ',
  'MİKOZ',
  'QÖNÇƏ',
  'MÜHİT',
  'PASTA',
  'PASAQ',
  'QƏZİL',
  'GİYİD',
  'MEYİL',
  'BAYKA',
  'QASİD',
  'ÇİLOV',
  'KOMOD',
  'SƏHƏR',
  'SƏRMƏ',
  'ŞƏDDƏ',
  'MÖCÜZ',
  'BƏYİM',
  'MASKA',
  'QURMA',
  'QƏNİM',
  'MƏCRA',
  'KÖPMƏ',
  'HOYDU',
  'NADAN',
  'SƏDƏF',
  'ÇANAQ',
  'DÖZMƏ',
  'MÜRUR',
  'KOBUR',
  'ÇƏKİL',
  'BUZOV',
  'ƏHATƏ',
  'KANAT',
  'ŞALAQ',
  'SİVİL',
  'SARAB',
  'QAQQA',
  'TEATR',
  'OXLOV',
  'ƏYYAŞ',
  'MUKOR',
  'ŞEHLİ',
  'KASET',
  'DƏVƏT',
  'NAƏHL',
  'DÖNMƏ',
  'HƏRİF',
  'RULET',
  'ÖYMƏK',
  'TAYFA',
  'BANAN',
  'KEFÇİ',
  'İDİOM',
  'BÖYLƏ',
  'QONİT',
  'MABƏD',
  'TƏZƏK',
  'ŞAYƏD',
  'MANTO',
  'NÖVHƏ',
  'BÖLMƏ',
  'DƏNLİ',
  'KÜYÇÜ',
  'ƏBƏDA',
  'QİYYƏ',
  'HİYLƏ',
  'QİBTİ',
  'QÖVMİ',
  'ƏBLƏH',
  'ŞƏRƏN',
  'MOLLA',
  'ÖNLÜK',
  'SÜİTA',
  'TUTYA',
  'İFRAZ',
  'MİRAB',
  'BARAN',
  'DUZAQ',
  'MAYİS',
  'EVENK',
  'KÖTƏK',
  'FAXİR',
  'İDMAN',
  'AVARƏ',
  'BAXTA',
  'LOYAL',
  'DƏBİR',
  'ƏKLİL',
  'CASUS',
  'KÜLƏK',
  'TƏSƏK',
  'NAQİS',
  'FAYDA',
  'DİKMƏ',
  'FƏHLƏ',
  'SÖYÜŞ',
  'KİLSƏ',
  'BƏNNƏ',
  'LƏLƏK',
  'ƏŞXAS',
  'ƏNDAM',
  'MƏRZƏ',
  'PAPAQ',
  'BOYAQ',
  'QOLUQ',
  'PEYDA',
  'KƏRİM',
  'AZƏRİ',
  'MİTOZ',
  'QARUN',
  'CİDAL',
  'DÜZCƏ',
  'İBRƏT',
  'ANBAR',
  'BEZMƏ',
  'ALBAN',
  'HOPMA',
  'CÜZAM',
  'ƏFRAD',
  'FİTRƏ',
  'GƏZMƏ',
  'BİRJA',
  'PİLLƏ',
  'MENYU',
  'LAKCA',
  'İNNAB',
  'TAHİR',
  'NAHAQ',
  'ƏKSƏR',
  'FİDAN',
  'AYİNƏ',
  'TAXMA',
  'ANQAR',
  'DƏMYƏ',
  'ŞORBA',
  'PAREZ',
  'BİYAR',
  'ÇOŞQA',
  'PENYA',
  'ARXAC',
  'BÜRUZ',
  'SƏFİL',
  'İTAƏT',
  'DİLÇİ',
  'TUMAC',
  'QÜSSƏ',
  'MOTOR',
  'BƏDGU',
  'ŞURİŞ',
  'LAKEY',
  'AMPUL',
  'ŞAMOT',
  'MƏXFİ',
  'BALBA',
  'QARUS',
  'DİNAB',
  'MALİK',
  'İNCİL',
  'BƏLGƏ',
  'ALTUN',
  'TİTUL',
  'QUMLU',
  'GƏLİŞ',
  'ƏMTƏƏ',
  'DULUS',
  'BÜKÜK',
  'ÇAYAN',
  'FÜZUN',
  'QONSƏ',
  'HÜCRƏ',
  'İLGƏK',
  'ÇİBİN',
  'BAXMA',
  'ƏRİZƏ',
  'ÜMUMİ',
  'CÖNGƏ',
  'KƏRƏN',
  'LEMUR',
  'DƏNDƏ',
  'FƏRDİ',
  'LƏHZƏ',
  'ŞİNLİ',
  'ƏLLAF',
  'ŞİKVƏ',
  'AZMAQ',
  'DOVLA',
  'DUZLU',
  'DİDAR',
  'QƏPİK',
  'OLİMP',
  'TARİX',
  'POLAD',
  'DƏMİN',
  'SİVRİ',
  'KÜLFƏ',
  'GÜCLÜ',
  'ÇİMİR',
  'KƏKOV',
  'NÜFUS',
  'BOMBA',
  'SLƏNQ',
  'ƏMƏLİ',
  'AŞMAQ',
  'NABUD',
  'KANOE',
  'İŞSİZ',
  'ƏTRAK',
  'KÖRPƏ',
  'ÇUŞKA',
  'BAŞAQ',
  'QUDOK',
  'SAKİN',
  'NƏMLİ',
  'MUAVR',
  'DAMBA',
  'QUCMA',
  'TƏRLİ',
  'TACİK',
  'KVOTA',
  'DÜDÜK',
  'PUSQU',
  'QƏZAL',
  'TUTUM',
  'HƏZƏR',
  'PEMZA',
  'ŞƏVƏL',
  'BATMA',
  'BULMA',
  'PUDRA',
  'QOŞUN',
  'HƏRÇİ',
  'MƏNƏN',
  'TÜHAF',
  'BÖYÜR',
  'QAŞQA',
  'ƏZBƏS',
  'NİSAR',
  'NÜZÜL',
  'ƏKRƏM',
  'ÇƏTİR',
  'SALDO',
  'KAMAN',
  'TƏPƏR',
  'DALDA',
  'ŞAHİN',
  'BÖCƏK',
  'PİLƏK',
  'KÜVET',
  'CAHİL',
  'QƏBİH',
  'PAMPA',
  'QALET',
  'ALÇAQ',
  'ƏŞƏDD',
  'ƏFSUS',
  'NORMA',
  'ƏNCAM',
  'MƏMAT',
  'NOVÇA',
  'İMSİK',
  'LİQAF',
  'HİNDİ',
  'İFRAQ',
  'GƏZƏL',
  'KLERK',
  'SÜDLÜ',
  'GÖDƏN',
  'MÜDİR',
  'ANONS',
  'NEMES',
  'NƏNNİ',
  'MARAL',
  'BİTKİ',
  'RƏVAN',
  'GÖNÇÜ',
  'QUŞÇU',
  'GÖZƏK',
  'MƏLAL',
  'SƏQQA',
  'ALMAN',
  'HÜBAB',
  'BİLMƏ',
  'LİMİT',
  'OMLET',
  'BÜZÜK',
  'BİÇMƏ',
  'ULAMA',
  'QAVAL',
  'LÜZUM',
  'AXŞAM',
  'GÜLÇÜ',
  'İSBAT',
  'ŞÜKÜR',
  'PƏNAH',
  'NİKOL',
  'DOMRA',
  'OLSUN',
  'SÜNBƏ',
  'BULAQ',
  'EVLİK',
  'KUBOK',
  'KƏRMƏ',
  'HEYİF',
  'FORMA',
  'TARİF',
  'QOTUR',
  'İFÇİN',
  'CÖVÜZ',
  'NƏFİR',
  'KONUS',
  'KOMİK',
  'QAYKA',
  'AVAZƏ',
  'GÜLAB',
  'AVRAL',
  'ŞƏRİF',
  'KOLAZ',
  'İMKAN',
  'BƏSİT',
  'SONRA',
  'SİYAH',
  'MODAL',
  'TƏQİB',
  'ƏDYAL',
  'GƏZİŞ',
  'BƏXİL',
  'DƏHƏN',
  'SAHİB',
  'ƏRZƏN',
  'ƏŞSİZ',
  'DUZƏX',
  'TONUS',
  'RƏCƏB',
  'SEZMƏ',
  'ARAMA',
  'ƏLCƏK',
  'OYLAQ',
  'REDUT',
  'GİRDƏ',
  'KATOD',
  'DÜJÜN',
  'NAÇİZ',
  'ŞUMAL',
  'KÜTÜB',
  'KONKİ',
  'SİCİM',
  'TABOR',
  'HÜNƏR',
  'DƏLİK',
  'DÖYÜN',
  'NİNNİ',
  'DƏCƏL',
  'İLHAM',
  'DÜSƏR',
  'ÇÜNKİ',
  'NƏFƏR',
  'FANUS',
  'SİMİN',
  'SƏDRİ',
  'ƏLHƏD',
  'ROTOR',
  'MAYKA',
  'SALTO',
  'GİLİZ',
  'SİLGİ',
  'ABRİZ',
  'KƏSRİ',
  'ÇALOV',
  'SUVAT',
  'DOMBA',
  'HAÇAQ',
  'GİCİK',
  'RADON',
  'SƏLƏF',
  'BƏZƏN',
  'EDİCİ',
  'BERET',
  'DOYUM',
  'SAÇAQ',
  'QƏLLƏ',
  'TƏSİS',
  'ÖLMÜŞ',
  'NİSYƏ',
  'QUCUM',
  'KALAN',
  'SEROZ',
  'NİFAQ',
  'MƏTBU',
  'TƏZİM',
  'QOŞAQ',
  'KƏBİN',
  'DABAQ',
  'QOLLU',
  'GÖRƏK',
  'LAYKA',
  'BÜSAT',
  'QARAJ',
  'BƏŞƏR',
  'FRENÇ',
  'POZMA',
  'QƏRBİ',
  'NİMÇƏ',
  'ŞÜBHƏ',
  'SONET',
  'GƏRDİ',
  'SORAQ',
  'BƏLKƏ',
  'ÇANTA',
  'ƏTLAS',
  'NƏZƏR',
  'AZMAN',
  'KÖZƏL',
  'İMDAD',
  'MORZE',
  'DAYAQ',
  'ERMƏK',
  'DÖVRİ',
  'KİTAB',
  'QƏLƏM',
  'SƏRİN',
  'EŞQLİ',
  'QANOV',
  'ÇİTƏK',
  'ÇEÇEN',
  'LOPUQ',
  'DONOR',
  'DƏRƏK',
  'HAFİZ',
  'ANTON',
  'MANQO',
  'DƏMÇİ',
  'KƏLƏF',
  'PEŞİN',
  'ŞLEYF',
  'TARLA',
  'ŞƏBAN',
  'KÖTÜK',
  'SÖYMƏ',
  'SOYAD',
  'TOTAL',
  'KNYAZ',
  'ÜMMƏT',
  'NEMƏT',
  'SUÇLU',
  'BANDA',
  'POQON',
  'BARİZ',
  'BÜTÜN',
  'ÇİNCƏ',
  'QÜRAB',
  'FƏRAQ',
  'KƏSRƏ',
  'BƏZİR',
  'ŞÜMUL',
  'AMYÖB',
  'SİNOV',
  'TƏBİR',
  'ƏSHAB',
  'ƏSRAR',
  'PLYAJ',
  'NƏZİR',
  'TƏSİR',
  'RAYON',
  'HUŞLU',
  'HÜRKÜ',
  'ÜÇGÜL',
  'MƏSƏL',
  'ŞAYBA',
  'RANET',
  'ŞLANQ',
  'KABUS',
  'MUCUL',
  'İÇƏİÇ',
  'MEŞOK',
  'ALLAH',
  'CƏSUR',
  'MOİZƏ',
  'BİKAM',
  'QAÇMA',
  'NASEH',
  'BƏNNA',
  'GOMUŞ',
  'İLHAQ',
  'BETƏR',
  'KÖYLÜ',
  'TÜKCƏ',
  'DALAN',
  'AZUQƏ',
  'BÖLÜŞ',
  'ƏRSİN',
  'QİYAQ',
  'MAJOR',
  'ROLİK',
  'RAXİT',
  'ATLAS',
  'ANTİK',
  'SALİM',
  'ŞƏRİD',
  'PAXLA',
  'HARAM',
  'SAQİT',
  'SÜMSÜ',
  'LAVAŞ',
  'ÖNDƏR',
  'İNSAN',
  'ŞƏHİD',
  'NADEL',
  'MƏZAR',
  'ŞAXİS',
  'ŞAİRƏ',
  'İSTƏR',
  'DOLUŞ',
  'ŞOTKA',
  'FİKRİ',
  'ARİZƏ',
  'LÜSTR',
  'TƏLƏT',
  'NİJAD',
  'SƏFHƏ',
  'DÖLMƏ',
  'QUMUQ',
  'OVSUN',
  'İNŞAD',
  'MAFAR',
  'HEYVA',
  'ÇEXCƏ',
  'ŞRİFT',
  'GÖVDƏ',
  'HƏNUZ',
  'BÜZMƏ',
  'OVDUQ',
  'DEYƏN',
  'MASAJ',
  'SİMLİ',
  'KABAB',
  'MASAL',
  'SİTRA',
  'PASXA',
  'GÖRÜM',
  'DONQA',
  'KEŞKƏ',
  'QAŞOV',
  'DRAJE',
  'BUDAL',
  'BİLET',
  'HƏRƏM',
  'ŞTANQ',
  'HÖRGÜ',
  'SİLLƏ',
  'MERAC',
  'BÜKÜŞ',
  'KAMİL',
  'KÜTLƏ',
  'SOYUQ',
  'SUSUZ',
  'DURAQ',
  'GİLAS',
  'KÖPƏK',
  'ƏLBİR',
  'TÜRFƏ',
  'MEŞİN',
  'TƏŞNƏ',
  'QOLFİ',
  'HÜCUM',
  'BADYA',
  'QAHAL',
  'BİTAB',
  'BİİZN',
  'DÜNKÜ',
  'GENİŞ',
  'KOLBA',
  'MƏLƏZ',
  'ÇÖHRƏ',
  'ARXİV',
  'KƏBİR',
  'SAYCA',
  'PLYUS',
  'BƏNƏK',
  'NƏSİB',
  'ÖZGÜN',
  'AGENT',
  'LAYİQ',
  'QNEYS',
  'KİPCƏ',
  'CİLET',
  'NİVAL',
  'SAVAR',
  'BİCƏK',
  'MAƏDA',
  'MUXUL',
  'ÖTMÜŞ',
  'ƏHALİ',
  'FATEH',
  'ŞİRMA',
  'BABAY',
  'QÜRUB',
  'MÜJDƏ',
  'RƏVAC',
  'BEŞİK',
  'BONUS',
  'FİRNİ',
  'DƏLİL',
  'SUİTİ',
  'ŞÜVÜL',
  'GÖZLÜ',
  'İFRİT',
  'FİTRİ',
  'TAPMA',
  'TARAN',
  'QONUR',
  'PƏRLİ',
  'ADİNƏ',
  'ƏNLİK',
  'ROYAL',
  'DƏŞNƏ',
  'KÜBAR',
  'GÜMÜŞ',
  'İXRAC',
  'SUSMA',
  'TOPAL',
  'ƏQDƏM',
  'KİRŞƏ',
  'QUMAŞ',
  'LİDER',
  'HAÇAN',
  'QAMMA',
  'ŞƏKVA',
  'SİLMƏ',
  'HERİK',
  'DOLAM',
  'SƏTHİ',
  'FƏRƏH',
  'FAZİL',
  'UNİYA',
  'NƏDİM',
  'ƏNBİR',
  'HƏPİR',
  'KEŞİK',
  'BİGAH',
  'DADAŞ',
  'BƏYAN',
  'DEFİS',
  'ODLAQ',
  'İLBİZ',
  'TOPAZ',
  'BOLLU',
  'ŞƏBİH',
  'TƏMƏL',
  'ÖLGÜN',
  'KƏRRƏ',
  'MAZER',
  'MADAM',
  'BATİN',
  'DƏRİN',
  'ŞİKAR',
  'HARAY',
  'ŞƏFİQ',
  'ÇÖLLÜ',
  'RİFAH',
  'ÇİNLİ',
  'ŞƏHRƏ',
  'ŞİMAL',
  'BİTUM',
  'KAZAK',
  'HALQA',
  'ÇAPMA',
  'NƏHVİ',
  'ÖKSÜZ',
  'RİCƏT',
  'QÜRRƏ',
  'OSTAN',
  'SƏKMƏ',
  'QƏRYƏ',
  'MALAY',
  'ŞƏLPƏ',
  'RƏNDƏ',
  'LƏKTƏ',
  'AMADƏ',
  'ƏTBAŞ',
  'DUYUQ',
  'SÖKMƏ',
  'CORAB',
  'ŞİŞƏK',
  'ƏRAZİ',
  'RƏDİF',
  'PETİT',
  'QUBAR',
  'ÇOLAQ',
  'ORDER',
  'QAROV',
  'FAUNA',
  'SÜKAN',
  'ANAŞA',
  'ƏCƏRİ',
  'SAXTA',
  'QONKA',
  'HƏSİR',
  'BƏLƏK',
  'QAYDA',
  'KÖMBƏ',
  'QAİDƏ',
  'DİVAR',
  'BOYAR',
  'DƏŞTİ',
  'ƏZVAY',
  'TORÇU',
  'İBRAZ',
  'GİYAH',
  'DANİŞ',
  'AXUND',
  'ƏQİDƏ',
  'QARMA',
  'NAMUS',
  'SEKAM',
  'KƏFLİ',
  'ÇUVAŞ',
  'İŞMƏK',
  'CƏNUB',
  'ƏXBAR',
  'EYMƏÇ',
  'HƏFTƏ',
  'DÜBBƏ',
  'TUMOV',
  'ÜLKƏR',
  'KƏMAL',
  'MƏRUF',
  'UÇUCU',
  'QAMƏT',
  'QAVOT',
  'DUYUŞ',
  'TİYAN',
  'OVDAN',
  'BALON',
  'HƏLQƏ',
  'HEYƏT',
  'TƏRƏF',
  'NASOS',
  'QOBOY',
  'MOKKO',
  'BİLGİ',
'ABDAL',
  'MƏLİK',
  'ŞEŞLİ',
  'BÜTÇÜ',
  'MURAD',
  'HİSSƏ',
  'SÜRVƏ',
  'ƏYYAR',
  'PİYLİ',
  'BİMAR',
  'FİQUR',
  'HÖRÜK',
  'FUQAS',
  'KÜTÜM',
  'CAHAN',
  'KƏLAM',
  'SƏTİR',
  'MESSA',
  'BİYAN',
  'TƏZAD',
  'MESAJ',
  'MƏBƏD',
  'PLİTƏ',
  'SONUC',
  'DÜGAH',
  'DAMLA',
  'ƏLHƏQ',
  'MÜFTİ',
  'TƏHƏR',
  'MULDA',
  'KÜRSÜ',
  'AMPER',
  'İBÇİN',
  'SÜLÜK',
  'DUVAQ',
  'BABAT',
  'BƏYƏM',
  'SOVXA',
  'QAÇAQ',
  'SEÇKİ',
  'DƏHRƏ',
  'ÖDƏMƏ',
  'NABAT',
  'KEFLİ',
  'PİNTİ',
  'QONMA',
  'OXŞAR',
  'TOTUŞ',
  'ŞPROT',
  'CÖVZƏ',
  'ÇİYİN',
  'LAFET',
  'CULFA',
  'PAPEY',
  'GİLLƏ',
  'QÖVŞƏ',
  'QOYUM',
  'KEFİR',
  'GÜNLÜ',
  'ƏZZƏL',
  'TƏKƏŞ',
  'İZOLƏ',
  'REJİM',
  'ADYAL',
  'TORLU',
  'ÇƏLİM',
  'HƏRİS',
  'BURSA',
  'DİŞLƏ',
  'FİRON',
  'TƏKƏR',
  'ÇEŞİD',
  'ƏTRAF',
  'SAÇMA',
  'UNİON',
  'SƏTRİ',
  'QİBLƏ',
  'ELLİK',
  'SƏKTƏ',
  'RETRO',
  'BƏDİƏ',
  'TİKİM',
  'BUFET',
  'ƏZBƏR',
  'QANDA',
  'SUVAQ',
  'MAYYA',
  'QODUQ',
  'CƏHRƏ',
  'KÜMÇÜ',
  'DÖHÜL',
  'KƏNƏK',
  'TÖVLƏ',
  'DURMA',
  'MİŞAR',
  'NASAZ',
  'POZUQ',
  'QƏNİR',
  'KƏMÇƏ',
  'İDEAL',
  'KƏKİL',
  'QİYAM',
  'BİHAL',
  'ÖRKƏN',
  'DÜXİŞ',
  'DOMCA',
  'KARAT',
  'SLAYD',
  'MAKET',
  'MACAL',
  'ÇAŞMA',
  'TİNLİ',
  'SATİN',
  'ŞÜƏRA',
  'QANMA',
  'QƏFƏS',
  'NACAQ',
  'ENSİZ',
  'MƏDƏD',
  'ŞƏRİR',
  'ŞİVƏN',
  'TALON',
  'BUXAR',
  'RETUŞ',
  'DEİZM',
  'NİKAH',
  'PEÇAT',
  'ÇÖKÜK',
  'HƏMƏN',
  'PORUQ',
  'ÇAPAR',
  'GƏLMƏ',
  'SƏVAB',
  'SƏNƏT',
  'MƏLUM',
  'EHKAM',
  'ÖVRAQ',
  'BAVƏR',
  'ASTAR',
  'SƏMUM',
  'LÖKÜT',
  'DOLÇA',
  'NORKA',
  'TİTAN',
  'GƏVƏN',
  'PƏDƏR',
  'FİRMA',
  'ŞÜYÜD',
  'SEVDA',
  'İTOTU',
  'KAHİL',
  'CÜMLƏ',
  'ƏNTƏR',
  'DODAQ',
  'KÖRÜK',
  'DƏFÇİ',
  'NƏBAT',
  'İCRƏT',
  'SMETA',
  'MUMLU',
  'BƏLƏD',
  'İTİCƏ',
  'ANCAQ',
  'SƏLİB',
  'ROMAN',
  'İÇMƏK',
  'MƏCMU',
  'ÖRPƏK',
  'TRİKO',
  'TARAŞ',
  'HAMPA',
  'HİCAB',
  'ÖRTÜK',
  'İDBAR',
  'HALAY',
  'ŞAŞMA',
  'AYAMA',
  'RÜBAB',
  'HÜQUQ',
  'NİGAH',
  'DÜÇAR',
  'DİKCƏ',
  'NƏFƏS',
  'BECİD',
  'MƏNŞƏ',
  'BUXAQ',
  'TƏKİR',
  'BAKAL',
  'ƏŞKAL',
  'KÜLLÜ',
  'DALAQ',
  'SÜMÜK',
  'GEYMƏ',
  'HƏKƏM',
  'MƏQAM',
  'CİYƏR',
  'BORAN',
  'MOQUR',
  'SÜRBƏ',
  'FƏTHƏ',
  'MƏQTƏ',
  'İBARƏ',
  'EKKER',
  'BUNCA',
  'SİTAT',
  'STEND',
  'DÖVRƏ',
  'OFSET',
  'SELSİ',
  'DAYÇA',
  'DİKLİ',
  'İLKİN',
  'TULUQ',
  'KÜRDİ',
  'TROMB',
  'DÜLƏR',
  'MAHUD',
  'SÜSƏN',
  'SÜBUT',
  'TONAL',
  'ƏRƏBİ',
  'BİELM',
  'RUMKA',
  'REQBİ',
  'KİMSƏ',
  'LÜTCƏ',
  'MƏRUZ',
  'NOQAY',
  'QALİB',
  'CƏFTƏ',
  'CƏNAB',
  'MƏHAL',
  'TƏXİR',
  'İNKAR',
  'BAXAR',
  'RENTA',
  'GÜZƏM',
  'DEVİZ',
  'TƏNƏK',
  'DAXİL',
  'QAPMA',
  'KANAL',
  'ƏLHAL',
  'TURŞU',
  'TÜRBƏ',
  'ÖTƏKİ',
  'CİVAR',
  'SEANS',
  'DÜTAR',
  'MÜCRÜ',
  'İFLİC',
  'KÖKLÜ',
  'ƏSMƏK',
  'FƏDAİ',
  'TELLİ',
  'PAXAR',
  'SÜDÇÜ',
  'BİQƏM',
  'NƏSLİ',
  'ÇƏTİN',
  'ƏMLİK',
  'ÜQƏLA',
  'DADMA',
  'ÜMƏRA',
  'GÖMMƏ',
  'PAKET',
  'ƏMBİZ',
  'KATAR',
  'TOPÇU',
  'SİMİC',
  'ƏSBAB',
  'DAİRƏ',
  'SAZİŞ',
  'GİROV',
  'İTMİL',
  'GƏLƏN',
  'DEYİŞ',
  'TÖKMƏ',
  'GƏMİK',
  'BİLƏK',
  'SELİK',
  'CƏRGƏ',
  'KİFLİ',
  'SƏMİR',
  'DƏRZİ',
  'FAQOT',
  'MODEM',
  'DÖYMƏ',
  'RƏSUL',
  'GÖLMƏ',
  'MANUL',
  'MUNDA',
  'ƏYLİK',
  'DÜYÜM',
  'HÖCƏT',
  'KƏVƏR',
  'DAMƏN',
  'TƏKCƏ',
  'ÇİMLİ',
  'UÇQUN',
  'MEYNƏ',
  'SİRAB'
]
